import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable()
export class CommandGridInputService {
    constructor(
        private _httpClient: HttpClient,
        private _apiService: ApiService,
    ) {
    }

    doGetSageDocumentAction(doDomaine: number, doType: number, doPiece: string) {
        let httparams = new HttpParams().set("DODomaine", doDomaine.toString()).set("DOType", doType.toString()).set("DOPiece", doPiece);
        return this._httpClient.get<any>(this._apiService.workspaceEndpointUrl + "/api/Soudotec/doGetSageDocumentAction_Soudotec", { params: httparams })
        .pipe(catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur')));
    }
}